import { render, staticRenderFns } from "./CompanyDialog.vue?vue&type=template&id=5813b3f4&scoped=true&"
import script from "./CompanyDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5813b3f4",
  null
  
)

export default component.exports